import React, { forwardRef, useState } from 'react';
import {
  GestureResponderEvent,
  StyleSheet,
  Text,
  TextProps,
} from 'react-native';
import {
  PressableAnalyticsProps,
  usePressableAnalytics,
} from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

type HyperlinkSmTextProps = PressableAnalyticsProps & TextProps;

const HyperlinkSmText = forwardRef<Text, HyperlinkSmTextProps>(
  ({ children, style, analyticsId, customAttributes, ...props }, ref) => {
    const [isPressed, setIsPressed] = useState(false);

    const linkAnalytics = usePressableAnalytics({
      analyticsId,
      customAttributes,
    });

    const handlePress = (event: GestureResponderEvent) => {
      setIsPressed(true);
      linkAnalytics?.();
      if (props?.onPress) {
        props.onPress(event);
      }

      setTimeout(() => {
        setIsPressed(false);
      }, 100);
    };

    return (
      <Text
        ref={ref}
        style={[styles.hyperlinkSmText, style]}
        testID={props.testID}
        accessible={true}
        accessibilityRole={props.accessibilityRole || 'link'}
        accessibilityLabel={props.accessibilityLabel}
        {...props}
        onPress={props.onPress ? handlePress : undefined}
        disabled={isPressed}
      >
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  hyperlinkSmText: {
    ...theme.typography.hyperlink.sm,
  },
});

export default HyperlinkSmText;
